import api from "./api";

export interface User {
  id: string;
  name: string;
  email: string;
  phone: string;
}

export interface Course {
  id: string;
  title: string;
  level: string;
}

export interface Enrollment {
  _id: string;
  user: User;
  course: Course;
  status: "pending" | "approved" | "rejected";
  notes?: string;
  createdAt: string;
  updatedAt: string;
  approvedAt?: string;
  rejectedAt?: string;
}

export const getEnrollments = async (): Promise<Enrollment[]> => {
  const response = await api.get("/enrollments");
  return response.data;
};

export const approveEnrollment = async (id: string): Promise<Enrollment> => {
  const response = await api.put(`/enrollments/${id}/approve`);
  return response.data;
};

export const rejectEnrollment = async (id: string): Promise<Enrollment> => {
  const response = await api.put(`/enrollments/${id}/reject`);
  return response.data;
};

export const deleteEnrollment = async (id: string): Promise<Enrollment> => {
  const response = await api.delete(`/enrollments/${id}`);
  return response.data;
};
